import React from 'react';
import { connect } from 'react-redux';
import { processEditHistories } from '../contractingUtils';
import { UpdateSummary } from '../../contracting-reports/diff-report/diffing/section-updateSummary';

const EditHistories = ({ editHistory, productsArray, diffSummary }) => {
  if (diffSummary) {
    return (
      <div>
        {
          (diffSummary.summaryByPage || []).length ? diffSummary.summaryByPage.map(({ header, pageSections }, index) => {
            return (
              <div key={header} style={{ marginTop: index ? '8px' : '0' }}>
                <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                  {header}
                </div>
                <div>
                  {
                    pageSections.map(({ label, updateSummary = [] }) => {
                      return (
                        <div
                          key={label}
                        >
                          <span>
                            {label}
                            {
                              Boolean(updateSummary.length) && (
                                <UpdateSummary
                                  updateSummary={updateSummary}
                                />
                              )
                            }
                          </span>
                        </div>
                      );
                    })
                  }
                </div>
              </div>
            );
          }) : <span>You haven't made any changes yet.</span>
        }
      </div>
    );
  }
  if (editHistory && editHistory.length) {
    const processed = processEditHistories(editHistory, productsArray);
    return (
      <div>
        {
          processed.map(({ name, details }, index) => {
            return (
              <div key={index}>
                {name ? <label style={{ fontWeight: 'bold' }}>{name}</label> : <label/>}
                {
                  details.split('|').map((detail, detailIndex, array) => {
                    if ((array[0] === 'Add product' || array[0] === 'Add new rate package') && detailIndex) return null;
                    return <li key={detailIndex}>{detail}</li>;
                  })
                }
              </div>
            );
          })
        }
      </div>
    );
  }
  return <div/>;
};

export default connect(({ contracting }) => {
  const productsArray = contracting.contractActivitiesProducts.getIn(['leftNav', 'productsArray']);
  return ({
    productsArray: productsArray ? productsArray.toJS() : [],
  });
})(EditHistories);




// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/editHistories.jsx